import React, { useEffect, useRef } from 'react';
import { Link } from 'gatsby';

const TicketExist = () => {

    const ticketExistRef = useRef(null);

    useEffect(() => {
        if (ticketExistRef.current) {
            ticketExistRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <div className="ticket-page__wrapper" ref={ticketExistRef}>

            <div className="thank-you">
                <div className="thank-you__logo">
                    <img src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/7b9962b7f4d80eb929d1cfdab242b8798256454c.png?v=1756753397" alt="logo" />
                </div>
                <h2 className="thank-you__title">
                    We've Got Your Request
                </h2>
                <p className="thank-you__description">
                    Thanks for reaching out! A support ticket for this request has already been created, and our team is currently reviewing it.

                </p>
                <p className="thank-you__description">
                    There's no need to submit another request — we'll follow up as soon as possible. Thank you for your patience and understanding.
                </p>

                <div className="thank-you__buttons">
                    <Link to="/" className='thank-you__button thank-you__button--primary '>
                        Homepage
                    </Link>

                    <Link to="/pages/faq" className='thank-you__button thank-you__button--secondary'>
                        Visit FAQ
                    </Link>

                </div>

                <p className="thank-you__description thank-you__description--narrow">
                    We know your time is valuable, and we’re here to make things right. Thanks for trusting us!
                </p>

                <p className="thank-you__description thank-you__description--last">
                    In case you’d like immediate assistance, our support team
                    is available at <a href="tel:8009150038">800-915-0038</a> or through live chat.
                </p>
            </div>
        </div>
    );
};

export default TicketExist;